import { render, staticRenderFns } from "./toolbar-insert.vue?vue&type=template&id=4bc304ca&"
import script from "./toolbar-insert.vue?vue&type=script&lang=js&"
export * from "./toolbar-insert.vue?vue&type=script&lang=js&"
import style0 from "./toolbar-insert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports